import React, { Component } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';

import Navbar from './navbar';
import Footer from './footer';

import landigCTA from './../assets/images/placeholder/landigCTA.png';
import photoWoman from './../assets/images/placeholder/photo-woman.jpeg';
import { resetUser } from '../actions/user-api';
import { resetAuth } from '../actions/auth-api';

export const Landing = () => {
    const dispatch = useDispatch();
    const hideModal = () => {
        $('.modal').modal("hide");
    }

    if (window.location.hostname === "localhost") {
        window.location = "http://localhost:3000/auth/partner/signin";
        return '';
    }
    window.location = "https://www.assistarobase.fr";
    return '';

    return (
        <div className="layout">
            <h1 className="sr-only visually-hidden">Assist@</h1>
            <Navbar />
            <main role="main" className="d-flex w-100 py-4 my-auto">
                <h1 className="sr-only visually-hidden">Assist@: Main</h1>
                <div className="container-fluid cover-container">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-5 text-center text-lg-left pt-5">
                            <h1 className="cover_h1 mt-n2 mb-sm mx-auto ml-lg-0">Accompagnement et aide à la gestion des formalités</h1>
                            <p className="cover_lead cover_lead-min mx-auto ml-lg-0 mb-6">Préparer vos démarches c'est faciliter demain</p>
                            <div className="cover_btns mx-auto ml-lg-0 mb-5 mb-lg-0 pt-gutter">
                                <Link to="/partner" className="btn btn-secondary mr-1 mr-lg-3">Accès partenaires</Link>
                                <Link to="/auth/signup/step1" className="btn btn-warning">Créer un compte</Link>
                            </div>
                        </div>
                        <div className="col-12 col-lg">
                            <img className="img-fluid mb-3 mb-lg-0" src={landigCTA} alt="Call to action" />
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}